/* ***** BEGIN LICENSE BLOCK *****
 * Distributed under the BSD license:
 *
 * Copyright (c) 2010, Ajax.org B.V.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *     * Redistributions of source code must retain the above copyright
 *       notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above copyright
 *       notice, this list of conditions and the following disclaimer in the
 *       documentation and/or other materials provided with the distribution.
 *     * Neither the name of Ajax.org B.V. nor the
 *       names of its contributors may be used to endorse or promote products
 *       derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL AJAX.ORG B.V. BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * ***** END LICENSE BLOCK ***** */

define('ace/theme/koken', ['require', 'exports', 'module' , 'ace/lib/dom'], function(require, exports, module) {

exports.isDark = true;
exports.cssClass = "ace-koken";
exports.cssText = ".ace-koken .ace_gutter {\
background: #1a1a1a;\
color: #707070\
}\
.ace-koken .ace_fold-widget:hover {\
border-color:#080808;\
box-shadow:0 1px 0 rgba(255,255,255,0.1)\
}\
.ace-koken {\
font-size:12px !important;\
}\
.ace-koken .ace_print-margin {\
display:none;\
width: 1px;\
background: #232323\
}\
.ace_scrollbar {\
background:#141414;\
}\
.ace-koken .ace_scroller {\
background-color: #141414\
}\
.ace-koken .ace_text-layer {\
color: #bbb\
}\
.ace-koken .ace_cursor {\
border-left: 2px solid #A7A7A7\
}\
.ace-koken .ace_overwrite-cursors .ace_cursor {\
border-left: 0px;\
border-bottom: 1px solid #A7A7A7\
}\
.ace-koken .ace_marker-layer .ace_selection {\
background: rgba(80, 80, 80, 0.3)\
}\
.ace-koken.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #141414\
border-radius: 2px\
}\
.ace-koken .ace_marker-layer .ace_step {\
background: rgb(102, 82, 0)\
}\
.ace-koken .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid rgba(255, 255, 255, 0.25)\
}\
.ace-koken .ace_marker-layer .ace_active-line {\
background: rgba(255, 255, 255, 0.001)\
}\
.ace-koken .ace_gutter-active-line {\
background-color: rgba(255, 255, 255, 0.05)\
}\
.ace-koken .ace_marker-layer .ace_selected-word {\
border: 1px solid rgba(255, 255, 255, 0.20)\
}\
.ace-koken .ace_invisible {\
color: rgba(255, 255, 255, 0.25)\
}\
.ace-koken .ace_keyword,\
.ace-koken .ace_meta {\
color: #CDA869\
}\
.ace-koken .ace_constant,\
.ace-koken .ace_constant.ace_character,\
.ace-koken .ace_constant.ace_character.ace_escape,\
.ace-koken .ace_constant.ace_other,\
.ace-koken .ace_markup.ace_heading,\
.ace-koken .ace_support.ace_constant,\
.ace-koken .ace_shortcode {\
color: #ff6e00\
}\
.ace-koken .ace_invalid.ace_illegal {\
color: #aaa;\
background-color: rgba(86, 45, 86, 0.75)\
}\
.ace-koken .ace_invalid.ace_deprecated {\
text-decoration: underline;\
font-style: italic;\
color: #D2A8A1\
}\
.ace-koken .ace_support {\
color: #9B859D\
}\
.ace-koken .ace_fold {\
background-color: #AC885B;\
border-color: #aaa\
}\
.ace-koken .ace_support.ace_function {\
color: #DAD085\
}\
.ace-koken .ace_markup.ace_list,\
.ace-koken .ace_storage {\
color: #F9EE98\
}\
.ace-koken .ace_entity.ace_name.ace_function,\
.ace-koken .ace_variable {\
color: #ff6e00\
}\
.ace-koken .ace_string {\
color: #7faace\
}\
.ace-koken .ace_string.ace_regexp {\
color: #E9C062\
}\
.ace-koken .ace_comment {\
font-style: italic;\
color: #5F5A60\
}\
.ace-koken .ace_variable {\
color: #7587A6\
}\
.ace-koken .ace_xml-pe {\
color: #494949\
}\
.ace-koken .ace_markup.ace_underline {\
text-decoration: underline\
}\
.ace-koken .ace_attribute-name {\
color:#ff6600\
}\
.ace-koken .ace_meta.ace_tag {\
color:#cc5200\
}\
.ace-koken .ace_shortcode {\
color:#fff\
}\
.ace-koken .ace_meta.ace_tag-name {\
color:#ff6600\
}\
.ace-koken .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWMQERH5zzBz5sz/AA5EBAYqeZXWAAAAAElFTkSuQmCC) right repeat-y\
}";

var dom = require("../lib/dom");
dom.importCssString(exports.cssText, exports.cssClass);
});
